import React from "react";
import { Modal } from "antd";
import { Heading, Button, Box } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { deleteFee } from "redux/actions/settingsActions";
import { Fee } from "types";

interface IConfirmDeleteFeeProps {
  showModal: boolean;
  setShowModal: (bool: boolean) => void;
  fee: Fee;
}

export default function ConfirmDeleteFee({
  showModal,
  setShowModal,
  fee,
}: IConfirmDeleteFeeProps) {
  const dispatch = useDispatch();
  const xJwt = localStorage.getItem("x_jwt");
  const handleCancel = () => {
    setShowModal(false);
  };

  const handleDelete = () => {
    dispatch(deleteFee(xJwt, fee._id, dispatch));
    setShowModal(false);
  };

  return (
    <>
      <Modal
        visible={showModal}
        onCancel={handleCancel}
        footer={null}
        width="40%"
        className="loan-config-modal"
      >
        <Box textAlign="center">
          <Heading as="h2" fontSize="sm" mb="4">
            Are you sure you want to delete this fee?
          </Heading>
          <Box d="block">
            <Button variant="danger" mr="4" onClick={handleDelete}>
              Delete
            </Button>
            <Button variant="secondary" onClick={handleCancel}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
